const LayoutManage = () => import('@/views/manage/layout')

const routes = [
//   {
//   path: '/site',
//   redirect: '/site/index',
//   component: LayoutManage,
//   children: [{
//     path: 'index',
//     component: () => import('@/views/manage/site/index'),
//     meta: {
//       title: '工作台',
//       img: '1.png'
//     }
//   }]
// }, 
{
  path: '/site/aide',
  redirect: '/site/aide/report',
  component: LayoutManage,
  alwaysShow: true,
  meta: {
    title: '站点助手',
    img: '5.png'
  },
  children: [{
    path: 'report',
    component: () => import('@/views/manage/site/aide/report'),
    meta: {
      title: '监测上报'
    }
  }]
}, {
  path: '/site/manage',
  redirect: '/site/manage/editUpwd',
  component: LayoutManage,
  alwaysShow: true,
  meta: {
    title: '用户管理',
    img: '4.png'
  },
  children: [{
    path: 'editUpwd',
    component: () => import('@/views/manage/site/manage/editUpwd'),
    meta: {
      title: '修改密码'
    }
  }]
}]
export default routes
